import { useState } from "react";
import useEvaApi, { EvaApiCall } from "../../../../hooks/useEvaApi";
import AxisConfigsPageView from "./AxisConfigsPageView";
import useCustomEffect from "../../../../hooks/useCustomEffect";

function AxisConfigsPage() {
  const callEvaApi = useEvaApi();
  const [submitError, setSubmitError] = useState(null);
  const [axisConfigData, setAxisConfigData] = useState({
    active: false,
  });

  /**
   * Initialize the component
   */
  useCustomEffect(() => {
    fetchAxisConfigData();
  });

  /**
   * This method will fetch the access commander 2N config data from the API
   */
  async function fetchAxisConfigData() {
    await callEvaApi(
      new EvaApiCall("integrations/axis/configs")
        .setLoadingGroup("axis_configs_page_fetch")
        .setOnSuccess((response) => {
          const newConfig = response.data.data;
          setAxisConfigData({
            active: newConfig?.active ?? false,
          });
        })
        .setRedirectOnError(true)
    );
  }

  /**
   * This method will update the active on input change
   * @param {bool} value 
   */
  function onActiveChange(value) {
    setAxisConfigData({ ...axisConfigData, active: value });
  }

  /**
   * This method will handle the submit functionality
   */
  async function onSubmit() {
    await callEvaApi(
      new EvaApiCall("integrations/axis/configs")
        .setMethod("PUT")
        .setData(axisConfigData)
        .setErrorState(setSubmitError)
        .setRedirectOnSuccess(true)
        .setLoadingGroup("axis_configs_page_save")
    );
  }

  return (
    <AxisConfigsPageView 
      axisConfigData={axisConfigData}
      onActiveChange={onActiveChange}
      onSubmit={onSubmit} 
      submitError={submitError}
    />
  );
}

export default AxisConfigsPage;